import dynamic from 'next/dynamic';

import { BundleLoader } from '../molecules';

import { OtpVerification, PhoneVerification } from './MobileLogin';

const Login = dynamic(() => import('./Login'), { loading: () => <BundleLoader /> });
const Home = dynamic(() => import('./Home'), { loading: () => <BundleLoader /> });
const Profile = dynamic(() => import('./Profile'), { loading: () => <BundleLoader /> });
const Registration = dynamic(() => import('./Registration'), { loading: () => <BundleLoader /> });
const ExploreJobsTab = dynamic(() => import('./ExploreJobsTab'), { loading: () => <BundleLoader /> });
const AppliedJobsTab = dynamic(() => import('./AppliedJobsTab'), { loading: () => <BundleLoader /> });
const SavedJobsTab = dynamic(() => import('./SavedJobsTab'), { loading: () => <BundleLoader /> });
const JobDetails = dynamic(() => import('./JobDetails'), { loading: () => <BundleLoader /> });
const VendorPageTemplate = dynamic(() => import('./VendorPage'), { loading: () => <BundleLoader /> });
const VendorRegisterTemplate = dynamic(() => import('./VendorRegister'), { loading: () => <BundleLoader /> });
const CandidateProject = dynamic(() => import('./CandidateProject'), { loading: () => <BundleLoader /> });
const CandidateOnboarding = dynamic(() => import('./CandidateOnboarding'), { loading: () => <BundleLoader /> });

export {
  Login,
  Home,
  Profile,
  Registration,
  ExploreJobsTab,
  AppliedJobsTab,
  SavedJobsTab,
  JobDetails,
  VendorPageTemplate,
  VendorRegisterTemplate,
  PhoneVerification,
  OtpVerification,
  CandidateProject,
  CandidateOnboarding
};
